import { useEffect } from 'react'
import AOS from 'aos'
import { SITE } from '../constants'
// import { consumeFormSource } from '@/helpers/sendMail'
import MetaInfo from '../components/common/MetaInfo'
import AppShowcase from '@sections/HomeAppShowcase'
import {WhyChooseServices } from '@sections/HomeWhyUs'
import StackServices from '@sections/HomeStackServices'
import WorkingProcess from '@sections/HomeWorkingProcess'
import SparkParticipation from '@sections/HomeSparkParticipation'
import OurImpact from '@sections/HomeOurImpact'
import TransformBanner from '@sections/TransformBanner'


export default function HomePage() {
//   useEffect(() => {
//   const params = new URLSearchParams(window.location.search)
//   if (params.has('res')) {
//     window.location.replace(`/sales-enquiry?${params.toString()}`)
//   }
// }, [])
// // REPLACE WITH
// useEffect(() => {
//   const params = new URLSearchParams(window.location.search)
//   if (!params.has('res')) return
//   const source = consumeFormSource()
//   if (source) window.location.replace(`${source}?res=${params.get('res')}`)
// }, [])
  //useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])
  return (
    <>
               <MetaInfo
        title={`Home ${SITE.metaTagPostText}`}
        description="CruxBytes Consultancy Services is an information technology company based in Thane/ Mumbai. Founded by Vikiraj Hinger with a vision to develop softwares and applications, we enable businesses and startups by delivering quality technology solutions. We exhibit strong expertise in developing complex B2C web applications and mobile apps."
        keywords=""
        // url="https://www.cruxbytes.com/"
        />
      <main id="main-content" >

  <div className="bg-grid" style={{background: 'var(--bg-hero)'}} aria-hidden="true"  />

  <AppShowcase />
  <WhyChooseServices />
    <StackServices />  
   <WorkingProcess />
  <SparkParticipation />
   <OurImpact />
  
<TransformBanner />
</main>
    </>
  )
}